// Shared photo-tile data for the customer app's "what are you interested in"
// category pickers (CustomerHome.jsx + CustomerBuyInstallation.jsx). Keeping
// this in one place means both screens always show the same photo + label
// for a given category key.
export const CATEGORY_TILES = [
  {
    key: "residential",
    label: "Home Solar",
    subtitle: "Rooftop panels",
    image: "https://images.unsplash.com/photo-1655300256335-beef51a914fe?w=600&q=80&auto=format&fit=crop",
  },
  {
    key: "commercial",
    label: "Commercial",
    subtitle: "Factory & warehouse",
    image: "https://images.unsplash.com/photo-1786913507799-0ddbb3e7dbb6?w=600&q=80&auto=format&fit=crop",
  },
  {
    key: "housing_society",
    label: "Housing Society",
    subtitle: "Apartment rooftops",
    image: "https://images.unsplash.com/photo-1613665813446-82a78c468a1d?w=600&q=80&auto=format&fit=crop",
  },
  {
    key: "ev_charger",
    label: "EV Charger",
    subtitle: "Fast charging unit",
    image: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?w=600&q=80&auto=format&fit=crop",
  },
  {
    key: "street_light",
    label: "Street Light",
    subtitle: "Solar poles",
    image: "https://images.unsplash.com/photo-1626006846694-f0852fa032f1?w=600&q=80&auto=format&fit=crop",
  },
  {
    key: "battery_storage",
    label: "Battery Storage",
    subtitle: "Backup power",
    image: "https://images.pexels.com/photos/37929911/pexels-photo-37929911.jpeg?w=600&q=80&auto=format&fit=crop",
  },
  {
    key: "others",
    label: "Others",
    subtitle: "Custom enquiry",
    image: "https://images.unsplash.com/photo-1660330589257-813305a4a383?w=600&q=80&auto=format&fit=crop",
  },
];

export const REFER_TILE = {
  key: "refer",
  label: "Refer & Earn",
  subtitle: "Reward for every friend",
  image: "https://images.unsplash.com/photo-1518135714426-c18f5ffb6f4d?w=600&q=80&auto=format&fit=crop",
};
